import appConfig from '~/config/app'
import { isAuthenticated } from '~/auth/slices/auth.slice'
import { useSubscriptionApplicabilityQuery } from '~/redux/apis/payment-api'
import { useAppSelector } from '~/redux/hooks'
import useSubscriptionIsRequired from '~/subscription/hooks/useSubscriptionIsRequired'

/** A logged-out visitor with nothing to buy signs up directly; unknown (loading or failed) keeps the onboarding. */
export default function useSkipsOnboarding(): boolean {
  const authenticated = useAppSelector(isAuthenticated)
  const { isSubscriptionRequired } = useSubscriptionIsRequired()
  const { isSuccess } = useSubscriptionApplicabilityQuery(undefined, {
    skip: authenticated || appConfig.isSchoolPlatform,
  })

  return !authenticated && isSuccess && !isSubscriptionRequired
}
